var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{style:({ width: '750px', height: '450px' }),attrs:{"id":"echart-line-history"}}),_c('div',{style:({ width: '750px', height: '450px' }),attrs:{"id":"echart-line-realtime"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }